<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm6>
                    <div>
                        <v-btn @click="newPlibel" large color="primary" class="no-print">Nueva hoja</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-layout>
                <v-flex xs12 sm6 offset-sm1>
                    <v-select v-model="prbFunc" :items="this.listPrbFunc" label="Historial" item-text="fecha"
                              return-object required class="no-print" @change="initializeRequiredObs"></v-select>
                </v-flex>
            </v-layout>
            <br>
            <v-expansion-panel v-model="panel" expand v-if="this.prbFunc!=null">
                <v-expansion-panel-content class="no-print">
                    <template v-slot:header>
                        <div> 1. Información personal y laboral</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.prbFunc.informacionLaboral"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==20" class="font-weight-bold">a. Datos de filiación</p>
                                        <p v-if="props.item.tipo==21" class="font-weight-bold">Identificación: {{$store.state.patient.identification}}</p>
                                        <p v-if="props.item.tipo==22" class="font-weight-bold">Apellidos y nombres: {{$store.state.patient.firstLastName}} {{$store.state.patient.secondLastName}}  {{$store.state.patient.firstName}} {{$store.state.patient.secondName}} </p>
                                        <p v-if="props.item.tipo==23" class="font-weight-bold">Edad: {{$store.state.patient.age}}</p>
                                        <p v-if="props.item.tipo==24" class="font-weight-bold">Empresa: {{$store.state.patient.company.name}}</p>
                                        <p v-if="props.item.tipo==25" class="font-weight-bold">Puesto de trabajo: {{$store.state.patient.jobCompany}}</p>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>A). VALORACIÓN FUNCIONAL OSTEOMUSCULAR DE HOMBRO</div>
                    </template>
                    <div align="center">
                        <table border="1">
                            <tbody>
                            <tr>
                                <td colspan="2"><b>MANIOBRA DE:</b></td>
                                <td><b>APLEY SUPERIOR</b></td>
                                <td><b>APLEY INFERIOR</b></td>
                            </tr>
                            <tr>
                                <td rowspan="2"><b>LIMITACIÓN</b></td>
                                <td>DERECHO</td>
                                <td>
                                    <v-switch v-model="prbFunc.switch1"
                                              :label="`${this.prbFunc.switch1 ? 'Si' : 'No'}`"
                                              @change="requireObs1"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch2"
                                              :label="`${this.prbFunc.switch2 ? 'Si' : 'No'}`"
                                              @change="requireObs2"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td>IZQUIERDO</td>
                                <td>
                                    <v-switch v-model="prbFunc.switch3"
                                              :label="`${this.prbFunc.switch3 ? 'Si' : 'No'}`"
                                              @change="requireObs1"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch4"
                                              :label="`${this.prbFunc.switch4 ? 'Si' : 'No'}`"
                                              @change="requireObs2"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2"><b>DOLOR:</b></td>
                                <td>DERECHO</td>
                                <td>
                                    <v-switch v-model="prbFunc.switch5"
                                              :label="`${this.prbFunc.switch5 ? 'Si' : 'No'}`"
                                              @change="requireObs1"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch6"
                                              :label="`${this.prbFunc.switch6 ? 'Si' : 'No'}`"
                                              @change="requireObs2"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td>IZQUIERDO</td>
                                <td>
                                    <v-switch v-model="prbFunc.switch7"
                                              :label="`${this.prbFunc.switch7 ? 'Si' : 'No'}`"
                                              @change="requireObs1"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch8"
                                              :label="`${this.prbFunc.switch8 ? 'Si' : 'No'}`"
                                              @change="requireObs2"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">OBS.</td>
                                <td><v-text-field
                                        name="obs1"
                                        label="Obs"
                                        id="obs1"
                                        v-model="prbFunc.obs1"
                                        :rules="obs1rules"
                                        :required="obs1required"
                                ></v-text-field></td>
                                <td><v-text-field
                                        name="obs2"
                                        label="Obs"
                                        id="obs2"
                                        v-model="prbFunc.obs2"
                                        :rules="obs2rules"
                                        :required="obs2required"
                                ></v-text-field></td>
                            </tr>
                            <tr>
                                <td colspan="2"><b>TEST DE:</b></td>
                                <td><b>IMPINGEMENT</b></td>
                                <td><b>JOBE</b></td>
                            </tr>
                            <tr>
                                <td colspan="2"><b>DERECHA</b></td>
                                <td>
                                    <v-switch v-model="prbFunc.switch9"
                                              :label="`${this.prbFunc.switch9 ? 'POSITIVO' : 'NEGATIVO'}`"
                                              @change="requireObs3"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch10"
                                              :label="`${this.prbFunc.switch10 ? 'POSITIVO' : 'NEGATIVO'}`"
                                              @change="requireObs4"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2"><b>IZQUIERDA:</b></td>
                                <td>
                                    <v-switch v-model="prbFunc.switch11"
                                              :label="`${this.prbFunc.switch11 ? 'POSITIVO' : 'NEGATIVO'}`"
                                              @change="requireObs3"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch12"
                                              :label="`${this.prbFunc.switch12 ? 'POSITIVO' : 'NEGATIVO'}`"
                                              @change="requireObs4"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">OBS.</td>
                                <td><v-text-field
                                        name="obs3"
                                        label="Obs"
                                        id="obs3"
                                        v-model="prbFunc.obs3"
                                        :rules="obs3rules"
                                        :required="obs3required"
                                ></v-text-field></td>
                                <td><v-text-field
                                        name="obs4"
                                        label="Obs"
                                        id="obs4"
                                        v-model="prbFunc.obs4"
                                        :rules="obs4rules"
                                        :required="obs4required"
                                ></v-text-field></td>
                            </tr>
                            </tbody>
                        </table>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>

                    </div>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>B). VALORACIÓN FUNCIONAL OSTEOMUSCULAR DE MUÑECA</div>
                    </template>
                    <div align="center">
                        <br>
                        <br>
                        <br>
                        <br>
                        <table border="1">
                            <tbody>
                            <tr>
                                <td colspan="2"><b></b></td>
                                <td><b>MANIOBRA DE PHALEN</b></td>
                                <td><b>SIGNO DE TINEL</b></td>
                            </tr>
                            <tr>
                                <td colspan="2"><b>DERECHA</b></td>
                                <td>
                                    <v-switch v-model="prbFunc.switch13"
                                              :label="`${this.prbFunc.switch13 ? 'POSITIVO' : 'NEGATIVO'}`"
                                              @change="requireObs5"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch14"
                                              :label="`${this.prbFunc.switch14 ? 'POSITIVO' : 'NEGATIVO'}`"
                                              @change="requireObs6"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">OBS.</td>
                                <td><v-text-field
                                        name="obs5"
                                        label="Obs"
                                        id="obs"
                                        v-model="prbFunc.obs5"
                                        :rules="obs5rules"
                                        :required="obs5required"
                                ></v-text-field></td>
                                <td><v-text-field
                                        name="obs6"
                                        label="Obs"
                                        id="obs6"
                                        v-model="prbFunc.obs6"
                                        :rules="obs6rules"
                                        :required="obs6required"
                                ></v-text-field></td>
                            </tr>
                            <tr>
                                <td colspan="2"><b>IZQUIERDA:</b></td>
                                <td>
                                    <v-switch v-model="prbFunc.switch15"
                                              :label="`${this.prbFunc.switch15 ? 'POSITIVO' : 'NEGATIVO'}`"
                                              @change="requireObs7"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch16"
                                              :label="`${this.prbFunc.switch16 ? 'POSITIVO' : 'NEGATIVO'}`"
                                              @change="requireObs8"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">OBS.</td>
                                <td><v-text-field
                                        name="obs7"
                                        label="Obs"
                                        id="obs7"
                                        v-model="prbFunc.obs7"
                                        :rules="obs7rules"
                                        :required="obs7required"
                                ></v-text-field></td>
                                <td><v-text-field
                                        name="obs8"
                                        label="Obs"
                                        id="obs8"
                                        v-model="prbFunc.obs8"
                                        :rules="obs8rules"
                                        :required="obs8required"
                                ></v-text-field></td>
                            </tr>
                            </tbody>
                        </table>
                        <table border="1">
                            <tbody>
                            <tr>
                                <td colspan="2"><b></b></td>
                                <td><b>VALORACIÓN SENSITIVA</b></td>
                                <td><b>VALORACIÓN MOTORA</b></td>
                            </tr>
                            <tr>
                                <td colspan="2"><b>DERECHA</b></td>
                                <td>
                                    <v-switch v-model="prbFunc.switch17"
                                              :label="`${this.prbFunc.switch17 ? 'NORMAL' : 'ANORMAL'}`"
                                              @change="requireObs9"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch18"
                                              :label="`${this.prbFunc.switch18 ? 'NORMAL' : 'ANORMAL'}`"
                                              @change="requireObs10"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">OBS.</td>
                                <td><v-text-field
                                        name="obs9"
                                        label="Obs"
                                        id="obs9"
                                        v-model="prbFunc.obs9"
                                        :rules="obs9rules"
                                        :required="obs9required"
                                ></v-text-field></td>
                                <td><v-text-field
                                        name="obs10"
                                        label="Obs"
                                        id="obs10"
                                        v-model="prbFunc.obs10"
                                        :rules="obs10rules"
                                        :required="obs10required"
                                ></v-text-field></td>
                            </tr>
                            <tr>
                                <td colspan="2"><b>IZQUIERDA:</b></td>
                                <td>
                                    <v-switch v-model="prbFunc.switch19"
                                              :label="`${this.prbFunc.switch19 ? 'NORMAL' : 'ANORMAL'}`"
                                              @change="requireObs11"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch20"
                                              :label="`${this.prbFunc.switch20 ? 'NORMAL' : 'ANORMAL'}`"
                                              @change="requireObs12"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">OBS.</td>
                                <td><v-text-field
                                        name="obs11"
                                        label="Obs"
                                        id="obs11"
                                        v-model="prbFunc.obs11"
                                        :rules="obs11rules"
                                        :required="obs11required"
                                ></v-text-field></td>
                                <td><v-text-field
                                        name="obs12"
                                        label="Obs"
                                        id="obs12"
                                        v-model="prbFunc.obs12"
                                        :rules="obs12rules"
                                        :required="obs12required"
                                ></v-text-field></td>
                            </tr>
                            </tbody>
                        </table>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                    </div>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div>C). VALORACIÓN FUNCIONAL DE COLUMNA</div>
                    </template>
                    <div align="center">
                        <br>
                        <br>
                        <br>
                        <table border="1">
                            <tbody>
                            <tr>
                                <td colspan="3"><b>PRUEBAS DE ROTACIÓN DE COLUMNA CERVICAL</b></td>
                            </tr>
                            <tr>
                                <td rowspan="2"><b>AMPLIACIÓN</b></td>
                                <td>DERECHA</td>
                                <td>
                                    <v-switch v-model="prbFunc.switch21"
                                              :label="`${this.prbFunc.switch21 ? 'NORMAL' : 'ANORMAL'}`"
                                              @change="requireObs13"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td>IZQUIERDA</td>
                                <td>
                                    <v-switch v-model="prbFunc.switch22"
                                              :label="`${this.prbFunc.switch22 ? 'NORMAL' : 'ANORMAL'}`"
                                              @change="requireObs13"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2"><b>LIMITACIÓN</b></td>
                                <td>DERECHA</td>
                                <td>
                                    <v-switch v-model="prbFunc.switch23"
                                              :label="`${this.prbFunc.switch23 ? 'SI' : 'NO'}`"
                                              @change="requireObs13"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td>IZQUIERDA</td>
                                <td>
                                    <v-switch v-model="prbFunc.switch24"
                                              :label="`${this.prbFunc.switch24 ? 'SI' : 'NO'}`"
                                              @change="requireObs13"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td><b>SINTOMAS</b></td>
                                <td colspan="2">
                                    <v-switch v-model="prbFunc.switch25"
                                              :label="`${this.prbFunc.switch25 ? 'SI' : 'NO'}`"
                                              @change="requireObs13"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td>OBS.</td>
                                <td colspan="2"><v-text-field
                                        name="obs13"
                                        label="Obs"
                                        id="obs13"
                                        v-model="prbFunc.obs13"
                                        :rules="obs13rules"
                                        :required="obs13required"
                                ></v-text-field></td>
                            </tr>
                            <tr>
                                <td colspan="3"><b>PRUEBAS DE ROTACIÓN DE COLUMNA EN</b></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td><b>EXTENSIÓN</b></td>
                                <td><b>FLEXIÓN</b></td>
                            </tr>
                            <tr>
                                <td><b>LIMITACIÓN</b></td>
                                <td>
                                    <v-switch v-model="prbFunc.switch26"
                                              :label="`${this.prbFunc.switch26 ? 'SI' : 'NO'}`"
                                              @change="requireObs14"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch27"
                                              :label="`${this.prbFunc.switch27 ? 'SI' : 'NO'}`"
                                              @change="requireObs14"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td><b>SINTOMAS</b></td>
                                <td>
                                    <v-switch v-model="prbFunc.switch28"
                                              :label="`${this.prbFunc.switch28 ? 'SI' : 'NO'}`"
                                              @change="requireObs14"></v-switch>
                                </td>
                                <td>
                                    <v-switch v-model="prbFunc.switch29"
                                              :label="`${this.prbFunc.switch29 ? 'SI' : 'NO'}`"
                                              @change="requireObs14"></v-switch>
                                </td>
                            </tr>
                            <tr>
                                <td>OBS.</td>
                                <td colspan="2"><v-text-field
                                        name="obs14"
                                        label="Obs"
                                        id="obs14"
                                        v-model="prbFunc.obs14"
                                        :rules="obs14rules"
                                        :required="obs14required"
                                ></v-text-field></td>
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <table border="1">
                                        <tbody>
                                        <tr>
                                            <td><b>PRUEBA DE COMPRESIÓN DEL AGUJERO INTERVERTEBRAL</b></td>
                                            <td><b>VALORACIÓN DE COLUMNA DORSAL</b></td>
                                            <td><b>VALORACIÓN DE COLUMNA LUMBAR</b></td>
                                            <td><b>PRUEBA FUNCIONAL DE ESPINAS ILÍACAS</b></td>
                                        </tr>
                                        <tr>
                                            <td>SÍNTOMAS</td>
                                            <td>SIGNO DE ADAMS</td>
                                            <td>SIGNO DE LASEGUE</td>
                                            <td>ART. SACROILÍACA</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <v-switch v-model="prbFunc.switch30"
                                                          :label="`${this.prbFunc.switch30 ? 'SI' : 'NO'}`"></v-switch>
                                            </td>
                                            <td>
                                                <v-switch v-model="prbFunc.switch31"
                                                          :label="`${this.prbFunc.switch31 ? 'PRESENTE' : 'AUSENTE'}`"></v-switch>
                                            </td>
                                            <td>
                                                <v-switch v-model="prbFunc.switch32"
                                                          :label="`${this.prbFunc.switch32 ? 'POSITIVO' : 'NEGATIVO'}`"></v-switch>
                                            </td>
                                            <td>
                                                <v-switch v-model="prbFunc.switch33"
                                                          :label="`${this.prbFunc.switch33 ? 'LIBRE' : 'BLOQUEADA'}`"></v-switch>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-form>
        <div class="text-xs-center" v-if="prbFunc!=null">
            <v-btn color="primary" class="no-print" @click="deleteForm" dark>Eliminar Registro</v-btn>
            <v-btn color="primary" class="no-print" @click="savePlibel" dark>Guardar</v-btn>
        </div>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import PruebasFuncionales from "../../../model/PruebasFuncionales"
    import PatientMonitoring from "../../../model/PatientMonitoring";

    export default {
        data() {
            return {
                panel:[true,true,true,true],
                prbFunc: null,
                listPrbFunc: [],
                valid: true,
                search: '',
                dialogError: false,
                dialogSuccess: false,
                obs1required: false,
                obs1rules: [],
                obs2required: false,
                obs2rules: [],
                obs3required: false,
                obs3rules: [],
                obs4required: false,
                obs4rules: [],
                obs5required: false,
                obs5rules: [],
                obs6required: false,
                obs6rules: [],
                obs7required: false,
                obs7rules: [],
                obs8required: false,
                obs8rules: [],
                obs9required: false,
                obs9rules: [],
                obs10required: false,
                obs10rules: [],
                obs11required: false,
                obs11rules: [],
                obs12required: false,
                obs12rules: [],
                obs13required: false,
                obs13rules: [],
                obs14required: false,
                obs14rules: [],
            }
        },
        methods: {

            newPlibel() {
                let d = new Date();
                let e = this.formatDate(d);
                this.prbFunc = new PruebasFuncionales();
                this.prbFunc.fecha = e
                this.listPrbFunc.push(this.prbFunc)
            },
            savePlibel() {
                if (this.$refs.form.validate()) {
                    this.$store.state.patientMonitoringList = []
                    if (this.prbFunc.id != '' && this.prbFunc.id != null) {
                        this.$store.dispatch('getPatientMonitoring', this.prbFunc.id).then(response => {
                            this.$store.state.patientMonitoringOne.value = JSON.stringify(this.prbFunc)
                            this.$store.dispatch('updatePatientMonitoring', this.$store.state.patientMonitoringOne).then(response => {
                                this.dialogSuccess = true
                                this.reloadData()
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                        })
                    } else {
                        let monitoringNew = new PatientMonitoring()
                        monitoringNew.date = new Date()
                        monitoringNew.value = JSON.stringify(this.prbFunc)
                        monitoringNew.form = 58
                        monitoringNew.patientRouteSheet = this.$store.state.routeSheet
                        this.$store.dispatch('addPatientMonitoring', monitoringNew).then(response => {
                            this.dialogSuccess = true
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },
            deleteForm(){
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientMonitoring',this.prbFunc.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },
            reloadData() {
                let data = new PatientMonitoring()
                data.form = 58
                data.patientRouteSheet = this.$store.state.routeSheet
                data.date = new Date()
                data.value = ""
                this.prbFunc = null
                this.$store.dispatch('getPatientMonitoringByRouteSheetForm', data).then(response => {
                    this.listPrbFunc = []
                    for (let i = 0; i < this.$store.state.patientMonitoringList.length; i++) {
                        let anam = JSON.parse(this.$store.state.patientMonitoringList[i].value)
                        anam.id = this.$store.state.patientMonitoringList[i].id
                        this.listPrbFunc.push(anam)
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            initializeRequiredObs() {
                this.requireObs1();
                this.requireObs2();
                this.requireObs3();
                this.requireObs4();
                this.requireObs5();
                this.requireObs6();
                this.requireObs7();
                this.requireObs8();
                this.requireObs9();
                this.requireObs10();
                this.requireObs11();
                this.requireObs12();
                this.requireObs13();
                this.requireObs14();
            },
            requireObs1() {
                if (this.prbFunc && (this.prbFunc.switch1 || this.prbFunc.switch3
                        || this.prbFunc.switch5 || this.prbFunc.switch7)) {
                    this.obs1required = true;
                    this.obs1rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs1required = false;
                    this.obs1rules = [];
                }
            },
            requireObs2() {
                if (this.prbFunc && (this.prbFunc.switch2 || this.prbFunc.switch4
                        || this.prbFunc.switch6 || this.prbFunc.switch8)) {
                    this.obs2required = true;
                    this.obs2rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs2required = false;
                    this.obs2rules = [];
                }
            },
            requireObs3() {
                if (this.prbFunc && (this.prbFunc.switch9 || this.prbFunc.switch11)) {
                    this.obs3required = true;
                    this.obs3rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs3required = false;
                    this.obs3rules = [];
                }
            },
            requireObs4() {
                if (this.prbFunc && (this.prbFunc.switch10 || this.prbFunc.switch12)) {
                    this.obs4required = true;
                    this.obs4rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs4required = false;
                    this.obs4rules = [];
                }
            },
            requireObs5() {
                if (this.prbFunc && this.prbFunc.switch13) {
                    this.obs5required = true;
                    this.obs5rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs5required = false;
                    this.obs5rules = [];
                }
            },
            requireObs6() {
                if (this.prbFunc && this.prbFunc.switch14) {
                    this.obs6required = true;
                    this.obs6rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs6required = false;
                    this.obs6rules = [];
                }
            },
            requireObs7() {
                if (this.prbFunc && this.prbFunc.switch15) {
                    this.obs7required = true;
                    this.obs7rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs7required = false;
                    this.obs7rules = [];
                }
            },
            requireObs8() {
                if (this.prbFunc && this.prbFunc.switch16) {
                    this.obs8required = true;
                    this.obs8rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs8required = false;
                    this.obs8rules = [];
                }
            },
            requireObs9() {
                if (this.prbFunc && !this.prbFunc.switch17) {
                    this.obs9required = true;
                    this.obs9rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs9required = false;
                    this.obs9rules = [];
                }
            },
            requireObs10() {
                if (this.prbFunc && !this.prbFunc.switch18) {
                    this.obs10required = true;
                    this.obs10rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs10required = false;
                    this.obs10rules = [];
                }
            },
            requireObs11() {
                if (this.prbFunc && !this.prbFunc.switch19) {
                    this.obs11required = true;
                    this.obs11rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs11required = false;
                    this.obs11rules = [];
                }
            },
            requireObs12() {
                if (this.prbFunc && !this.prbFunc.switch20) {
                    this.obs12required = true;
                    this.obs12rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs12required = false;
                    this.obs12rules = [];
                }
            },
            requireObs13() {
                if (this.prbFunc && (!this.prbFunc.switch21 || !this.prbFunc.switch22
                    || this.prbFunc.switch23 || this.prbFunc.switch24 || this.prbFunc.switch25)) {
                    this.obs13required = true;
                    this.obs13rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs13required = false;
                    this.obs13rules = [];
                }
            },
            requireObs14() {
                if (this.prbFunc && (this.prbFunc.switch26 || this.prbFunc.switch27
                    || this.prbFunc.switch28 || this.prbFunc.switch29)) {
                    this.obs14required = true;
                    this.obs14rules = [v => !!v || 'Campo requerido'];
                } else {
                    this.obs14required = false;
                    this.obs14rules = [];
                }
            }
        },
        computed: {},
        created() {
            this.reloadData();
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/patient/musculoEsqueletico/PruebasFuncionales.vue